
import { config } from 'util/config';
import React, { Fragment } from 'react';
import { Space, Card, Table, Pagination, Modal, Tag, Tooltip, Button, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';
import { PlusOutlined, EditOutlined, DeleteOutlined, PlusSquareOutlined, UnlockOutlined, FolderOpenOutlined, ProfileOutlined, FullscreenOutlined, FullscreenExitOutlined, GroupOutlined } from '@ant-design/icons';
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';

export default class CustomButton extends React.Component {
  constructor(props) {
    super();
    this.state = {
      isTooltipOpen: false
    }

    this.timeout = null;
  };

  handleMouseEnter = () => {
    this.timeout = setTimeout(() => {
      this.setState({ isTooltipOpen: true });
    }, config.component.Tooltip.mouseEnterDelay * 1000);
  }

  handleMouseLeave = () => {
    this.setState({ isTooltipOpen: false });
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  //创建按钮
  createButton({ button, section, sectionComponent, pageComponent, parameter } = {}) {
    let icon = null;
    let type = button.type;
    let style = config.component.Icon.style;
    let iconFormat = parameter.IconFormat !== undefined ? parameter.IconFormat.filter(item => item.actionType == button.actionType) : {};
    let buttonFormat = parameter.ButtonFormat !== undefined ? parameter.ButtonFormat.filter(item => item.actionType == button.actionType) : {};

    switch (button.icon) {
      case 'PlusOutlined':
        icon = <PlusOutlined style={style} />;
        break;
      case 'EditOutlined':
        icon = <EditOutlined style={style} />;
        break;
      case 'UnlockOutlined':
        icon = <UnlockOutlined style={style} />;
        break;
      case 'DeleteOutlined':
        icon = <DeleteOutlined style={style} />;
        break;
      case 'PlusSquareOutlined':
        icon = <PlusSquareOutlined style={style} />;
        break;
      case 'FolderOpenOutlined':
        icon = <FolderOpenOutlined style={style} />;
        break;
      case 'ProfileOutlined':
        icon = <ProfileOutlined style={style} />;
        break;
      case 'FullscreenOutlined':
        icon = <FullscreenOutlined style={style} />;
        break;
      case 'FullscreenExitOutlined':
        icon = <FullscreenExitOutlined style={style} />;
        break;
      case 'GroupOutlined':
        icon = <GroupOutlined style={style} />;
        break;
      case null:
        icon = null;
        break;
      default:
        let icons = button.icon.split(';');
        //默认获取第一个icon, 有可能会根据数据改变icon
        icon = <img className={'svg-img-btn ' + (button.flip ? 'flip' : '')} src={'assets/images/icon/' + icons[0].trim()} />;
        //如果有自定义的 IconFormat, 获取对应 actionType 和 iconIndex
        if (iconFormat.length > 0) {
          icon = <img className={'svg-img-btn ' + (button.flip ? 'flip' : '')} src={'assets/images/icon/' + icons[iconFormat[0].iconIndex].trim()} />;
        }
        break;
    }
    switch (button.actionType) {
      case 'Delete':
        return <Popconfirm
          disabled={buttonFormat[0]?.disabled}
          placement="bottom"
          title={button.confirmText !== null ? button.confirmText : config.component.defaultDeleteConfirmText}
          onConfirm={() => operationalFunction({ uie: button, functionName: button.onClick, sectionName: section.name, parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent })}
        >
          <Tooltip open={this.state.isTooltipOpen && (iconFormat[0]?.title !== undefined || button.title !== null)} disabled={buttonFormat[0]?.disabled} title={iconFormat[0]?.title === undefined ? button.title !== null ? button.title : null : iconFormat[0]?.title}>
            <Button
              size={config.component.Button.size}
              icon={icon}
              type={type}
              danger={button.danger}
              className={button.className}
              disabled={buttonFormat[0]?.disabled}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
            >{button.text}</Button>
          </Tooltip >
        </Popconfirm>
      default:
        return <Tooltip open={this.state.isTooltipOpen && (iconFormat[0]?.title !== undefined || button.title !== null)} disabled={buttonFormat[0]?.disabled} title={iconFormat[0]?.title === undefined ? button.title !== null ? button.title : null : iconFormat[0]?.title}>
          <Button
            size={config.component.Button.size}
            icon={icon}
            type={type}
            danger={button.danger}
            className={button.className}
            disabled={buttonFormat[0]?.disabled}
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            onClick={() => operationalFunction({ uie: button, functionName: button.onClick, sectionName: section.name, parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent })}
          >{button.text}</Button>
        </Tooltip >
    }
  }

  render() {
    return (
      <>{this.createButton({
        button: this.props.button,
        section: this.props.section,
        sectionComponent: this.props.sectionComponent,
        pageComponent: this.props.pageComponent,
        parameter: this.props.parameter
      })}</>
    );
  }
}
